import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'Elements';
import {
	clx,
	companySettlementStatus,
	formatLocaleDateTime,
	getKeyFromValue
} from 'Utils';
import { Colors, Invoice, TransactionStatus } from 'Types';
import styles from 'partials/card/subscription-card.module.scss';
import { SkeletonInvoicePayment } from '../skeleton/SkeletonInvoicePayment';

interface Props {
	transaction: Invoice;
	isLoading: boolean;
}
export const InvoicePayment: FC<Props> = ({ transaction, isLoading }) => {
	const { t } = useTranslation();
	const payStatus = transaction?.status;
	const transactionStatus = getKeyFromValue(TransactionStatus, payStatus);
	const badgeText = transactionStatus
		? t(`badge.${transactionStatus.toLowerCase()}`)
		: '';
	const getStatusData = () => {
		return companySettlementStatus.find((elem) => elem.value === payStatus);
	};

	return isLoading ? (
		<SkeletonInvoicePayment />
	) : (
		<div>
			<h6 className="text-gray-3 mb-3 fs-6 fw-400 d-flex align-items-center justify-content-between">
				{t('title.payment.key')}
				<Badge color={getStatusData()?.color ?? Colors.muted}>
					{badgeText}
				</Badge>
			</h6>
			<div className={clx(styles.row, 'justify-content-between')}>
				<span className={styles.rowLabel}>
					{t('label.payment-date')}:
				</span>
				<span>
					{transaction?.createdAt
						? formatLocaleDateTime(transaction?.createdAt)
						: '---'}
				</span>
			</div>
			<div
				className={clx(styles.row, 'justify-content-between border-0')}>
				<span className={styles.rowLabel}>
					{t('label.payment-reference')}:
				</span>
				<span>{transaction?.provider?.paymentReference || '---'}</span>
			</div>
			<div className={clx(styles.row, 'justify-content-between')}>
				<span className={styles.rowLabel}>
					{t('label.payment-method')}:
				</span>
				<span>{transaction?.provider?.paymentMethodInfo || '---'}</span>
			</div>
		</div>
	);
};
